import React from 'react';
import {v4 as uuid} from 'uuid';
import {getRequest} from "@requests";
import {connect} from "react-redux";
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {delay} from "@helpers/functions";
import {withTranslation} from "react-i18next";

class SingleSelectSearch extends React.Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            optionSelect: null,
            optionsSelectSearch: [],
        };
        this.changeSelect = this.changeSelect.bind(this);
        this.changeInput = this.changeInput.bind(this);
        this.initialization = this.initialization.bind(this);
        this.initialization();
        this._isMounted = true;
    }
    async initialization() {
        const {apiDomainVikon, defaultValue, scheme} = this.props;
        if (defaultValue > 0) {
            const optionSingleSelect = await getRequest(`${apiDomainVikon}${scheme.type.url}${defaultValue}`);
            if (!optionSingleSelect.errors) {
                if (this._isMounted) {
                    this.setState({optionSelect: optionSingleSelect});
                }
            }
        }
    }
    changeSelect(newValue) {
        this.setState({optionSelect: newValue});
    }
    async changeInput(newInputValue) {
        if (newInputValue.length >= 3) {
            const {apiDomainVikon, scheme} = this.props;
            const options = await getRequest(`${apiDomainVikon}${scheme.type.url}search?query=${newInputValue}`);
            if (!options.errors) {
                if (this._isMounted) {
                    this.setState({optionsSelectSearch: options});
                }
            }
        } else {
            if (this._isMounted) {
                this.setState({optionsSelectSearch: []});
            }
        }
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    render() {
        const {name, scheme, refs, i18n} = this.props;
        const {optionSelect, optionsSelectSearch} = this.state;
        const {changeSelect, changeInput} = this;
        const idPostfix = uuid();
        const isLabelEn = i18n.language === 'en' && scheme.label_en
        return (
            <React.Fragment>
                <input type="hidden" ref={input => refs[name] = input} value={optionSelect ? optionSelect.id : 0} />
                <Autocomplete
                    id={name + '_' + idPostfix}
                    options={optionsSelectSearch}
                    getOptionLabel={(option) => option.value}
                    renderInput={(params) => <TextField {...params} label={isLabelEn ? scheme.label_en: scheme.label} variant="outlined" size="small" fullWidth required={scheme.required === true}/>}
                    onChange={(event, newValue) => {
                        changeSelect(newValue);
                    }}
                    getOptionSelected={(option, value) => option.id === value.id}
                    onInputChange={(event, newInputValue) => {
                        delay(() => {changeInput(newInputValue)}, 500);
                    }}
                    value={optionSelect}/>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        apiDomainVikon: state.apiDomainVikon,
    };
}

export default connect(mapStateToProps)(withTranslation()(SingleSelectSearch));